import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { MainAPI } from "../../../axios/api";
import {
  useAbortedEffect,
  useSearch,
  useTable,
  useTab,
  usePop,
} from "../../../components/hooks";
import moment from "moment";

import ModuleBreadCrumb from "../../../components/breadCrumb";
import ModulePopReportRadar from "./popRadar";
import ModuleQuestionType1 from "../question/popType1";
import ModuleQuestionType2 from "../question/popType2";
import ModuleQuestionType3 from "../question/popType3";
import {
  formatOptions,
  setPageSetting,
  cleanObj,
} from "../../../service/common";
import { system_dropdown, system_table } from "../../../service/system";
import {
  option_enabled,
  option_question,
  option_level,
  option_q_title,
} from "../../../service/option";
import { generateFile } from "./setting";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";

export default function BackReportList(props) {
  const route_navigate = useNavigate();
  const dispatch = useDispatch();
  const crumbItem = [{ key: 1, label: "統計報表" }];
  const pagePath = "/report";
  const { tabData, activeIndex, renderTab } = useTab({
    moduleType: "underline",
    data: [
      { key: 1, label: "問卷一", sm_label: "問卷一", value: 1, type: "type1" },
      {
        key: 2,
        label: "問卷二",
        sm_label: "問卷二",
        value: 2,
        type: "type2",
      },
      {
        key: 3,
        label: "問卷三",
        sm_label: "問卷三",
        value: 3,
        type: "type3",
      },
    ],
    matchTab: [pagePath],
  });
  const {
    tbData,
    setTbData,
    tbTotalRecords,
    setTbTotalRecords,
    setTbFirstIndex,
    setTbRows,
    setTbColumns,
    renderTable,
    setPageAction,
  } = useTable();
  const [reload, setReload] = useState({ list: false });
  // 篩選條件
  const defaultFilter = {
    detail: 1,
    page: 1,
    size: 10,
    memberid: -1,
  };
  const {
    filterData,
    setFilterData,
    search,
    setSearch,
    changeFilter,
    renderSearchWrap,
  } = useSearch({
    defaultFilter,
    pagePath: [pagePath],
    tbSetting: { setTbFirstIndex, setTbRows },
    reloadAction: () => setReload((state) => ({ ...state, list: true })),
  });
  const { isPop, popOption, openPop, closePop, renderDialog } = usePop([
    {
      key: "radar",
      title: () => "雷達圖",
      isOpen: false,
    },
    {
      key: "question",
      title: ({ data }) => option_q_title[data.qType],
      isOpen: false,
    },
  ]);
  const [optionData, setOptionData] = useState({});
  const [checkData, setCheckData] = useState({ all: false });

  useAbortedEffect((signal) => {
    let params = {
      page: -1,
    };

    MainAPI.getUserList({ data: params, options: { signal } }).then(
      (result) => {
        let { Response, data, message } = result;

        if (Response === 1) {
          let temp = {
            ...formatOptions(
              {
                userList: data,
              },
              { uniqueKey: "id", showLabel: "username" }
            ),
          };
          formatOptionDetail(temp);
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }
      }
    );
  }, []);

  const formatOptionDetail = (detail) => {
    let temp = formatOptions({
      enabled: option_enabled,
      level_type1: option_level.type1,
      level_type2: option_level.type2,
      level_type3: option_level.type3,
    });

    setOptionData((state) => ({
      ...state,
      ...temp,
      ...detail,
      question: option_question,
      question_title: option_q_title,
    }));
  };

  useEffect(() => {
    if (activeIndex === null) return;

    setReload((state) => ({
      ...state,
      list: true,
    }));
  }, [activeIndex]);

  // 取得列表資料
  useAbortedEffect(
    (signal) => {
      if (!reload.list) return;

      dispatch(setProgress(true));

      setPageSetting({
        params: {
          ...search,
          memberid: search.memberid ?? null,
        },
        page: pagePath,
        tab: tabData[activeIndex]?.type,
      });

      let params = {
        ...search,
        memberid: search.memberid ?? -1,
      };

      let promise;
      switch (tabData[activeIndex].type) {
        case "type1":
          promise = MainAPI.getQuestionnaireData1List({
            data: params,
            options: { signal },
          });
          break;
        case "type2":
          promise = MainAPI.getQuestionnaireData2List({
            data: params,
            options: { signal },
          });
          break;
        case "type3":
          promise = MainAPI.getQuestionnaireData3List({
            data: params,
            options: { signal },
          });
          break;
        default:
          promise = MainAPI.getQuestionnaireData1List({
            data: params,
            options: { signal },
          });
      }

      promise.then((result) => {
        let { Response, data, total, message } = result;

        if (Response === 1) {
          let tempCheck = { ...checkData };
          tempCheck.all = !data.some((item) => !tempCheck[item.id]);
          setCheckData(tempCheck);

          setTbData(data);
          setTbTotalRecords(total);
          setReload((state) => ({
            ...state,
            list: false,
          }));
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [reload]
  );

  useEffect(() => {
    if (!optionData) return;

    const renderCheckHead = () => (
      <>
        <div className="flex align-items-center">
          <Checkbox
            className="mr-2"
            value=""
            onChange={(e) => checkChange("all", e, -1)}
            checked={checkData.all}
          ></Checkbox>
          <label className="m-0">全選</label>
        </div>
      </>
    );

    const renderCheckBody = (data, rowIndex) => (
      <>
        <Checkbox
          value=""
          onChange={(e) =>
            checkChange("single", e, rowIndex % system_table.size)
          }
          checked={checkData[data.id] ? true : false}
        ></Checkbox>
      </>
    );

    const renderEnabled = (data) => (
      <span
        className={classNames({
          "text-red-400": data.enabled === 0,
          "text-green-400": data.enabled === 1,
        })}
      >
        {optionData.enabled_obj?.[data.enabled]?.showLabel}
      </span>
    );

    const renderUsername = (data) => (
      <>{optionData.userList_obj?.[data.memberid]?.showLabel ?? "-"}</>
    );

    const renderBtnAction = (data) => (
      <>
        <Button
          className="p-button-sm p-button-info mr-2"
          type="button"
          label="雷達圖"
          onClick={() =>
            openPop({
              type: "radar",
              data: {
                qType: tabData[activeIndex].type,
                id: data.id,
              },
            })
          }
        />
        <Button
          className="p-button-sm p-button-primary mr-2"
          type="button"
          label="檢視"
          onClick={() =>
            openPop({
              type: "question",
              data: {
                ...data,
                qType: tabData[activeIndex].type,
              },
            })
          }
        />
        <Button
          className="p-button-sm p-button-warning"
          type="button"
          label="匯出"
          onClick={() => exportFile({ type: "raw", data: [data] })}
        />
      </>
    );

    setTbColumns([
      {
        field: "id",
        header: "",
        className: "w-6rem",
        header: (data) => renderCheckHead(data),
        body: (data, { rowIndex }) => renderCheckBody(data, rowIndex),
      },
      {
        field: "username",
        header: "帳號",
        className: "flex-grow-1",
        style: { flexBasis: "120px" },
        body: (data) => renderUsername(data),
      },
      {
        field: "date",
        header: "日期",
        className: "flex-grow-1",
        style: { flexBasis: "120px" },
      },
      // {
      //   field: "updatedatetime",
      //   header: "填答日期",
      //   className: "flex-grow-1",
      //   style: { flexBasis: "120px" },
      // },
      {
        field: "id",
        header: "進階",
        className: "w-13rem froze-right",
        alignFrozen: "right",
        frozen: true,
        body: (data) => renderBtnAction(data),
      },
    ]);
  }, [pagePath, optionData, checkData, activeIndex]);

  const getAllData = () => {
    dispatch(setProgress(true));

    let params = {
      ...search,
      page: -1,
      memberid: search.memberid ?? -1,
    };

    let promise;
    switch (tabData[activeIndex].type) {
      case "type1":
        promise = MainAPI.getQuestionnaireData1List({
          data: params,
        });
        break;
      case "type2":
        promise = MainAPI.getQuestionnaireData2List({
          data: params,
        });
        break;
      case "type3":
        promise = MainAPI.getQuestionnaireData3List({
          data: params,
        });
        break;
      default:
        promise = MainAPI.getQuestionnaireData1List({
          data: params,
        });
    }

    promise.then((result) => {
      let { Response, data, message } = result;

      if (Response === 1) {
        exportFile({ type: "raw", data });
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: message,
            detail: "",
          })
        );
      }

      dispatch(setProgress(false));
    });
  };

  const exportFile = ({ type, data }) => {
    dispatch(setProgress(true));

    let tempCheck = { ...checkData };
    delete tempCheck.all;

    let reportData = type === "raw" ? [...data] : [...Object.values(tempCheck)];

    reportData = reportData.map((item) => ({
      member: {
        username: optionData.userList_obj?.[item.memberid]?.showLabel,
        date: item.date,
      },
      question: item,
    }));

    if (reportData.length === 0) {
      dispatch(
        setToast({
          severity: "warn",
          summary: "請選擇匯出項目",
          detail: "",
        })
      );
      dispatch(setProgress(false));
      return;
    }

    generateFile({
      reportData,
      reportType: tabData[activeIndex].type,
      optionData,
      finishAction: () => dispatch(setProgress(false)),
    });
  };

  // 勾選比較項目
  const checkChange = (type, e, rowIndex) => {
    let tempCheck = { ...checkData };

    if (type === "all") {
      tbData.forEach((item) => {
        if (!e.checked) delete tempCheck[item.id];
        else tempCheck[item.id] = item;
      });

      tempCheck = { ...tempCheck, all: e.checked };
      setCheckData(tempCheck);
    } else if (type === "single") {
      if (!e.checked) delete tempCheck[tbData[rowIndex].id];
      else tempCheck[tbData[rowIndex].id] = tbData[rowIndex];

      let checkedAll = !tbData.some((item) => !tempCheck[item.id]);
      tempCheck = { ...tempCheck, all: checkedAll };
      setCheckData(tempCheck);
    }
  };

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <h2 className="my-3 ml-1">統計報表</h2>

      <div className="border-round-lg bg-white p-3">
        <div className="mb-2">{renderTab}</div>

        {renderSearchWrap({
          isShow: false,
          template: (
            <>
              <div className="col-12 md:col-4 xl:col-3 flex align-items-start flex-column mt-2 md:mt-0">
                <label
                  htmlFor="memberid"
                  className="w-4rem white-space-nowrap text-left mb-1"
                >
                  帳號
                </label>
                <Dropdown
                  name="memberid"
                  className="w-full"
                  value={filterData.memberid}
                  onChange={(e) => changeFilter(e)}
                  options={optionData.userList}
                  optionLabel="username"
                  optionValue="id"
                  emptyFilterMessage={system_dropdown.emptyFilter}
                  showClear
                />
              </div>

              <div className="col-12 md:col-8 xl:col-9 flex align-items-end">
                <Button
                  className="p-button-main p-button-sm w-auto ml-auto md:ml-0 mt-2 md:mt-0 px-3"
                  type="button"
                  icon="pi pi-search"
                  label="查詢"
                  onClick={() => {
                    setSearch({ ...filterData, page: 1 });
                    setTbFirstIndex(0);
                    setCheckData({ all: false });
                  }}
                />
              </div>
            </>
          ),
        })}

        <div className="my-2">
          <Button
            className="p-button-sm p-button-warning"
            type="button"
            label="勾選多筆匯出"
            onClick={() => exportFile({ type: "check" })}
          />
          <Button
            className="p-button-sm p-button-warning ml-2"
            type="button"
            label="全部匯出"
            onClick={() => getAllData()}
          />
        </div>

        {renderTable({
          options: { scrollable: true, scrollDirection: "both" },
        })}
      </div>

      {renderDialog({
        className: classNames("w-11 lg:w-8 md:w-9 sm:w-10", {
          "max-w-35rem": isPop.radar?.isOpen,
        }),
        children: (
          <>
            {isPop.radar?.isOpen && (
              <ModulePopReportRadar
                closePrePop={closePop}
                popPreOption={popOption}
              />
            )}

            {isPop.question?.isOpen && (
              <>
                {activeIndex === 0 && (
                  <ModuleQuestionType1
                    closePrePop={closePop}
                    popPreOption={popOption}
                  />
                )}
                {activeIndex === 1 && (
                  <ModuleQuestionType2
                    closePrePop={closePop}
                    popPreOption={popOption}
                  />
                )}
                {activeIndex === 2 && (
                  <ModuleQuestionType3
                    closePrePop={closePop}
                    popPreOption={popOption}
                  />
                )}
              </>
            )}
          </>
        ),
      })}
    </>
  );
}
